import Store from "../../../../../Store";
import { NEW_LANG_MAP } from "../AlphabetModal";

export const isAlphabetAvailable = (langPair) =>
  !!Store.getAlphabetData(langPair.split("-")[0], langPair.split("-")[1]) ||
  Object.keys(NEW_LANG_MAP).includes(langPair);
